module.exports = __webpack_public_path__ + "media/assets/img/screenshots/best-efforts-341fedaec3fac3a4342c162b2413af03.png";